import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './artstamm.template.html',
    styleUrls: ['./artstamm.template.scss']
})
export class ArtstammTemplate implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
